import { useState } from "react";
const get = (id, fallback = undefined) => {
    if (typeof localStorage === "undefined") {
        return fallback;
    }
    const value = localStorage.getItem("devui_" + id);
    if (value !== null) {
        try {
            return JSON.parse(value);
        }
        catch (err) {
            return fallback;
        }
    }
    else {
        return fallback;
    }
};
const set = (id, value) => {
    localStorage.setItem("devui_" + id, JSON.stringify(value));
};
export function usePersistState(id, initial) {
    const [value, setValue] = useState(() => get(id, initial));
    return [
        value,
        (value) => {
            if (typeof value === "function") {
                return setValue((cur) => {
                    const next = value(cur);
                    set(id, next);
                    return next;
                });
            }
            else {
                set(id, value);
                setValue(value);
            }
        },
    ];
}
